export default class DAWAResponseFormatter {
    /**
     *
     * @param {Object} response
     * @return {{adresse: {id}, tekst: *}}
     */
    static convertAddressToAutoCompleteLike(response) {
        return {
            adresse: {id: response.id},
            tekst: response.adressebetegnelse
        }
    }

    /**
     * @param {Array} response
     * @param {Object} address
     *
     * @return {Array}
     */
    static extendAddressAutoComplete(response, address) {
       let filteredResponse = response.filter(item => item.adresse.id !== address.adresse.id);
       filteredResponse.push(address);

       return filteredResponse;
    }
}


// WEBPACK FOOTER //
// ./web/src/services/DAWAResponseFormatter.js